import { requestAppConfigAdmin } from './auth';
import { API_ENV_PROD } from '../utils/apiEnvironment';

export const RELEASE_QUERY_KEY = 'mobileReleases';
export const RELEASE_CANDIDATE_QUERY_KEY = 'mobileReleaseCandidates';

export function productionOtaActionsEnabled(
  apiEnvironment,
  dispatchEnabled = process.env.REACT_APP_ENABLE_PRODUCTION_OTA_ACTIONS === 'true',
) {
  return apiEnvironment === API_ENV_PROD && dispatchEnabled;
}

export async function listMobileReleases() {
  return requestAppConfigAdmin('/api/v0/mobile/releases');
}

export async function createMobileRelease(version, environment, distributionRecord = {}) {
  return requestAppConfigAdmin('/api/v0/mobile/releases', {
    method: 'POST',
    body: JSON.stringify({ version_name: version, status: 'DRAFT', title: `Fancian ${version}`, ...distributionRecord }),
    expectedEnvironment: environment,
  });
}

export async function updateMobileRelease(id, input, environment) {
  return requestAppConfigAdmin(`/api/v0/mobile/releases?id=${id}`, {
    method: 'PATCH',
    body: JSON.stringify(input),
    expectedEnvironment: environment,
  });
}

export async function listReleaseCandidates() {
  return requestAppConfigAdmin('/api/v0/mobile/release-candidates');
}

export async function syncReleaseCandidates() {
  return requestAppConfigAdmin('/api/v0/mobile/release-candidates/sync', { method: 'POST' });
}

export async function updateReleaseCandidate(id, input, environment) {
  return requestAppConfigAdmin(`/api/v0/mobile/release-candidates?id=${id}`, {
    method: 'PATCH',
    body: JSON.stringify(input),
    expectedEnvironment: environment,
  });
}

export async function refreshMobileRelease(releaseId) {
  return requestAppConfigAdmin(`/api/v0/mobile/releases/${releaseId}/sync`, {
    method: 'POST',
  });
}

export async function requestOtaAction(releaseId, otaId, input) {
  return requestAppConfigAdmin(`/api/v0/mobile/releases/${releaseId}/otas/${otaId}/actions`, {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export function actionConfirmation(action, rollout, platform) {
  if (action === 'DEPLOY') return 'DEPLOY PRODUCTION 5%';
  if (action === 'EXPAND') return `EXPAND PRODUCTION TO ${rollout}%`;
  if (action === 'ROLLBACK') return `ROLLBACK PRODUCTION ${String(platform || '').toLowerCase()}`.trim();
  return '';
}
